<template>
  <header v-loading.fullscreen="loading">
    <div class="header full_layout" @mouseleave="hideMenu('userinfo')">
      <div class="flex_display flex_one">
        <a href="/" class='logo'>
          <img src="../../static/images/logo.svg">
        </a>
        <ul class='headerMenu flex_one'>
          <li :class="(path[0]==''||path[0]=='home')?'on':''" @mouseenter="hideMenu('market')">
            <router-link :to="{path:'/'}">{{headerMeu['home']}}</router-link>
          </li>
          <li :class="(path[0]=='market')?'on':''"><span @mouseenter="showMenu('market')">{{headerMeu['market']}}</span></li>
          <!-- <li :class="(path[0]=='point')?'on':''" @mouseenter="hideMenu('market')">
            <router-link :to="{path:'/point'}">{{headerMeu['point']}}</router-link>
          </li>
          <li :class="(path[0]=='cypher')?'on':''">
            <router-link :to="{path:'/user/exchange'}" v-if="userInfo!=null">{{headerMeu['cypher']}}</router-link>
            <span v-else @click="goLogin('login')">{{headerMeu['cypher']}}</span>
          </li> -->
          <li :class="(path[0]=='information')?'on':''">
            <router-link :to="{path:'/info'}">{{headerMeu['information']}}</router-link>
          </li>
          <!-- <li :class="(path[0]=='about')?'on':''">
            <router-link :to="{path:'/about'}">{{headerMeu['about']}}</router-link>
          </li> -->
        </ul>
      </div>
      <!-- 搜索商品 -->
      <el-input placeholder="Search" v-model="searchTxt" class="headerSearch">
        <i slot="prefix" class="searchIcon"></i>
      </el-input>
      <!--  -->
      <!-- 购物车 -->
      <div class='cart' @mouseenter="hideMenu('userinfo')">
        <span @click="goLogin('login')" v-if="userInfo==null"></span>
        <el-badge is-dot class="item" v-if="userInfo!=null&&iscart">
          <router-link :to="{path:'/cart'}"></router-link>
        </el-badge>
        <router-link v-if="userInfo!=null&&!iscart" :to="{path:'/cart'}"></router-link>
      </div>
      <!--  -->
      <!-- 登录 -->
      <div class="topUser">
        <span @click="goLogin('login')" v-if="userInfo==null">Sign In</span>
        <span class="userOn" @mouseenter="showMenu('userinfo')" v-if="userInfo!=null" :class="userInfo.Level>1?'lv lv'+userInfo.Level:''"></span>
      </div>
      <!--  -->
      <!-- 类目下拉 -->
      <div class="getmarket" v-if="dislogType.market&&category!=null" @mouseleave="hideMenu('market')">
        <ul class="marketfirst">
          <li v-for="(item,index) in category" :key='index' @mouseenter="setChildren(index)" :class="categoryIndex==index?'on':''">{{item.label}}</li>
        </ul>
        <ul class="marketsecond">
          <li v-for="(it,i) in category[categoryIndex].children" :key="i">
            <span @click="MenuUserGo('/market?f='+it.Fid+'&s='+it.id,'market')">{{it.label}}</span>
          </li>
        </ul>
      </div>
      <!--  -->
      <!-- 用户下拉 -->
      <div class="getuserinfo" v-if="dislogType.userinfo" @mouseleave="hideMenu('userinfo')">
        <ul class="getuserinfoUl">
          <li>
            <div @click="MenuUserGo('/user/info','userinfo')">
              <span class="icon_user"></span>
              Personal information
            </div>
          </li>
          <li>
            <div @click="MenuUserGo('/user/order','userinfo')">
              <span class="icon_order"></span>
              My orders
            </div>
          </li>
          <!-- <li>
            <div @click="MenuUserGo('/message','userinfo')">
              <span class="icon_message"></span>
              我的消息
            </div>
          </li> -->
          <li>
            <div @click="MenuUserGo('/user/address','userinfo')">
              <span class="icon_add"></span>
              My addresses
            </div>
          </li>
          <li>
            <div @click="MenuUserGo('/cart','userinfo')">
              <span class="icon_cart"></span>
              Shopping cart
            </div>
          </li>
          <!-- <li>
            <div @click="MenuUserGo('/user/point','userinfo')">
              <span class="icon_point"></span>
              Points
            </div>
          </li>
          <li>
            <div @click="MenuUserGo('/user/exchange','userinfo')">
              <span class="icon_exchange"></span>
              Cypher
            </div>
          </li> -->
          <li>
            <div @click="MenuUserGo('','userinfo')">
              <span class="icon_layout"></span>
              Sign out
            </div>
          </li>
        </ul>
      </div>
      <!--  -->
    </div>
    <!-- 登录 -->
    <to-login title='Sign In' :domVisible='dislogType.login' @closeDialog="closeDialog" @godialog='godialog' v-if="dislogType.login" />
    <!-- 注册 -->
    <to-register title='Sign up' :domVisible='dislogType.register' @closeDialog="closeDialog" @godialog='godialog' v-if="dislogType.register" />
    <!-- 忘记密码 -->
    <to-forgot title='Forgot password' :domVisible='dislogType.forgot' @closeDialog="closeDialog" @godialog='godialog' v-if="dislogType.forgot" />
  </header>
</template>
<script>
import { getInfo, toLogout,CookiesCategory,setInfo} from "@/api/public";
import ToLogin from '@/components/dialog/login' //登录
import ToRegister from '@/components/dialog/register' // 注册
import ToForgot from '@/components/dialog/forgot' // 忘记密码
export default {
  name: 'topheader',
  components: { ToLogin, ToRegister, ToForgot },
  data() {
    return {
      userInfo:getInfo(),
      category:null,
      categoryIndex:0,
      iscart:false,
      loading:false,
      userInfo: '',
      headerMeu: this.$enumInfo.headerMeu,
      searchTxt: null,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  inject: ['reload'],
  props: {
    path: Array,
    isPath: Boolean,
  },
  mounted() {
    let that = this
    window.addEventListener('keydown', function(e) {
      if (that.searchTxt!=null) {
        if (e.keyCode === 13) {
          that.$root.$emit("newSearch", that.searchTxt);
          that.$router.push({ path: '/market?search='+that.searchTxt });
        }
      }
    })

    this.$root.$on("newSearch", val => {
      this.searchTxt = val;
    })
    this.$root.$on("newCart",val => {
      this.iscart = val;
    })
    this.$root.$on("newInfo",val => {
      this.userInfo = getInfo();
    })

  },
  created() {
    this.userInfo = getInfo();
    this.getCartList();
    this.getCategoryList();
    if(this.$route.name=='market'){
      this.searchTxt=this.$route.query.search
    }
    if((this.path[0]=='cart'||this.path[0]=='checkout')&&this.userInfo!=null){
      this.GetMemberInfo()
    }
    const type=this.$route.query.type
    console.log(type,'type')
    if(type==='SignIn'){
      this.goLogin('login')
    }else if(type==='Forgot'){
      this.goLogin('forgot')
    }
  },
  methods: {
    GetMemberInfo(){
      let that=this;
      let info=getInfo();
      console.log(info,'info')
      let data={MemberId:info._id}
      that.$get(that.$interface.GetMemberInfoById,data).then(res=>{
        if(res.Result!=0){
          that.userInfo=res.Data;
          //newInfo
          setInfo('Level',res.Data.Level);
          that.$root.$emit("newInfo",res.Data.Level);
        }else{
          that.$message.error(res.Msg);
        }
        that.loading=false
      }).catch({})
      //console.log('data',data)
    },
    // 获取分类
    getCategoryList() {
      let that = this
      let fun = function(res) {
        that.category = res
      }
      CookiesCategory('get', '', 'miaoshop', fun)
      // getCategory().then(res => {
      //   let data = resetCategory(res.Data);
      //   this.Category = data;
      // })
    },
    // 显示二级分类
    setChildren(val){
      this.categoryIndex=val
    },
    // 获取购物车列表
    getCartList(){
      let that=this;
      if(that.userInfo!=null){
        let data={MemberId:that.userInfo._id,PageIndex:1,PageSize:1};
        that.$get(that.$interface.GetMyCartPageList,data).then(res=>{
          if(res.Result!=0){
            that.iscart=res.Count>0?true:false;
          }else{
            that.iscart=false;
          }
        }).catch({})
      }
    },
    // 跳转页面
    MenuUserGo(val, name) {
      this.hideMenu(name);
      if (name == 'userinfo' && val == '') {
        this.loading=true;
        toLogout()
      } else { 
        this.$router.push({ path: val }) 
      }
    },
    showMenu(val) {
      this.dislogType[val] = true
    },
    hideMenu(val) {
      this.categoryIndex=0
      this.dislogType[val] = false
    },
    //goLogin 和 showMenu 应该是一样的，到时候删掉goLogin
    goLogin(val) {
      this.dislogType[val] = true
    },
    godialog(val, bol) {
      this.dislogType[val] = bol
    },
    closeDialog(val, bol) {
      this.userInfo = getInfo();
      this.dislogType[val] = bol;
      // 登陆状态 刷新一次页面
      if(this.userInfo!=null){
        this.reload();
        // this.getCartList();
        // this.$root.$emit("isLogin", true);
      }
    },
    // Logout() {
    //   this.reload()
    // },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/header.css";

</style>



// WEBPACK FOOTER //
// src/components/header.vue